export const dateIsRecent = (date: Date) => {
  const now = new Date();
  const diff = now.getTime() - date.getTime();
  return diff < 30 * 60 * 1000; // 30 minutes
};
